import { environmentLabel, findEnvironment } from "./template";
import { COMPARISON_VIEWER } from "../bomViewer/flags";

export const isComparisonOutput = (output) =>
  (output.outputType || "").toLowerCase().startsWith("comp") || /_comp\.xlsx$/i.test(output.name || "");

export const isTraceOutput = (output) => (output.outputType || "").toLowerCase() === "trace";

export const isExternalOutput = (output) => ["Agile", "Oracle"].includes(findEnvironment(output.environment)?.kind);

export const isBomOutput = (output) => !isComparisonOutput(output) && !isTraceOutput(output);

const isExternalEnvironment = (key) => ["Agile", "Oracle"].includes(findEnvironment(key)?.kind);

export const canOpenComparison = (input) =>
  COMPARISON_VIEWER &&
  input.outputs.some(isComparisonOutput) &&
  !isExternalEnvironment(input.environmentA) &&
  !isExternalEnvironment(input.environmentB) &&
  !input.outputs.some(isExternalOutput);

export const summaryOutputFor = (input) =>
  input.outputs.filter(isComparisonOutput).sort((a, b) => a.id - b.id)[0] ||
  input.outputs.filter((o) => isBomOutput(o) && !isExternalOutput(o)).sort((a, b) => a.id - b.id)[0] ||
  null;

export const shortEnvironment = (key) =>
  (environmentLabel(key) || "").replace(/On-Premise /g, "").replace(/Infor Cloud/g, "Cloud");
